"use client";

import { type HTMLAttributes, forwardRef } from "react";
import { InputLabel, Wrapper } from "./input";
import { cn } from "./lib/utils";

export interface TextAreaProps extends HTMLAttributes<HTMLTextAreaElement> {
	name: string;
	label?: string;
	value?: string;
	required?: boolean;
	disabled?: boolean;
	placeholder?: string;
}

export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
	({ label, required, className, ...props }, ref): React.ReactElement => {
		return (
			<Wrapper>
				{label ? <InputLabel required={required} text={label} /> : null}
				<textarea
					className={cn(
						"bg-transparent text-md",
						"outline-none",
						"h-24",
						className,
					)}
					ref={ref}
					required={required}
					{...props}
				/>
			</Wrapper>
		);
	},
);

TextArea.displayName = "TextArea";
